import Box from '@components/base/Box'
import { GetMembershipDetailsOutput } from '@graphql/__generated/graphql'
import { CreateEventContext, EventCreation } from '@libs/CreateEventContext'
import { useAuth } from '@libs/Auth/useAuth'
import { useOrganisationProfile } from '@libs/useOrganisationProfile'
import Resizeable from '@libs/Utility/resizeable'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { getEmailPreviewContent } from './util'

export const EmailPreview = ({
  content,
  resizeEnabled = true,
  show = true,
  data,
  type = 'event',
}: {
  show?: boolean
  resizeEnabled?: boolean
  content: string
  data?: Partial<EventCreation | GetMembershipDetailsOutput>
  type?: 'event' | 'membership'
}) => {
  const { profile } = useAuth()
  const { formData } = useContext(CreateEventContext)
  const org = useOrganisationProfile(profile?.company!)

  const [height, setHeight] = useState<number | undefined>()

  const iframeRef = useRef<HTMLIFrameElement>(null)

  const emailContent = getEmailPreviewContent(
    content,
    'Test',
    org.profile.logoImage,
    data ?? formData,
    type
  )

  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe || !content) return

    // Write the full HTML document into the iframe
    const doc = iframe.contentDocument || iframe.contentWindow?.document
    iframe
    if (doc) {
      doc.open()
      // doc.append(emailContent)
      doc.write(emailContent)
      doc.close()

      // Optional: Auto-resize iframe to content height
      // const resize = () => {
      //   if (iframe.contentWindow) {
      //     setHeight(iframe.contentWindow.document.body.scrollHeight)
      //   }
      // }

      // Wait for styles/images to load
      iframe.onload = () => {
        doc.addEventListener('click', (e) => {
          e.preventDefault() // 🚫 stop navigation
        })
      }

      // iframe.onload = () => {
      // setTimeout(resize, 100) // small delay for fonts/images
      // }

      // Also resize on window resize or content change
      // window.addEventListener('resize', resize)
      // return () => window.removeEventListener('resize', resize)
    }
  }, [content, show])

  if (!show) return <></>

  return (
    <>
      {/* <Box className="font-normal text-md">Email Preview</Box> */}
      <Resizeable
        className="h-full w-full flex-1"
        enabled={resizeEnabled}
        initalSize={{ height: 'full' }}
      >
        <iframe
          ref={iframeRef}
          title="Email Preview"
          className="w-full h-full rounded border border-white border-solid border-opacity-25 relative"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          style={{
            width: '100%',
            height: '100%',
            border: '1px solid #ddd',
            borderRadius: '8px',
          }}
          sandbox="allow-same-origin" // improve security
        />
      </Resizeable>
    </>
  )
}
